import { render, staticRenderFns } from "./OrderFlowAllPage.vue?vue&type=template&id=2f8b67a5&scoped=true&"
import script from "./OrderFlowAllPage.vue?vue&type=script&lang=js&"
export * from "./OrderFlowAllPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b67a5",
  null
  
)

export default component.exports